(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const demo = root.querySelector('[data-demo]');
    const caption = root.querySelector('[data-demo-caption]');
    const demoImage = demo.querySelector('img');
    const demoCard = demo.querySelector('.tb-demo-card');
    const demoPhone = demo.querySelector('.tb-phone');
    let demoTimers = [];
    let demoAnimations = [];
    let demoVisible = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const stopTimers = () => {demoTimers.forEach(window.clearTimeout); demoTimers = [];};
    const delay = (callback, milliseconds) => demoTimers.push(window.setTimeout(callback, milliseconds));
    function setStage(stage) {
      demo.dataset.state = String(stage);
      caption.textContent = caption.getAttribute('data-caption-' + stage);
    }
    function runDemo() {
      stopTimers();
      demoAnimations.forEach(animation => animation.cancel());
      demoAnimations = [];
      demo.dataset.paused = 'false';
      if (reduced.matches) {setStage(3); return;}
      if (!demoImage.complete || !demoImage.naturalWidth || !demoVisible || document.hidden) return;
      setStage(1);
      const cardBounds = demoCard.getBoundingClientRect();
      const phoneBounds = demoPhone.getBoundingClientRect();
      const approach = Math.max(40, Math.min(180, phoneBounds.left + phoneBounds.width * 0.2 - cardBounds.left - cardBounds.width * 0.52));
      const cardApproach = approach * 0.62;
      const phoneApproach = approach * 0.38;
      const motionTiming = {duration:9000, easing:'cubic-bezier(.4,0,.2,1)',fill:'both'};
      demoAnimations.push(demoCard.animate([
        {transform:'translate(-12px, 16px) rotate(-5deg) scale(1)',offset:0},
        {transform:`translate(${cardApproach}px, -32px) rotate(9deg) scale(1.06)`,offset:0.14},
        {transform:`translate(${cardApproach}px, -32px) rotate(9deg) scale(1.06)`,offset:0.24},
        {transform:'translate(0, 0) rotate(-2deg) scale(1.04)',offset:0.39},
        {transform:'translate(0, -6px) rotate(-2deg) scale(1.04)',offset:0.82},
        {transform:'translate(-12px, 16px) rotate(-5deg) scale(1)',offset:1}
      ], motionTiming));
      demoAnimations.push(demoPhone.animate([
        {transform:'translate(10px, 8px) rotate(5deg)',offset:0},
        {transform:`translate(-${phoneApproach}px, -6px) rotate(-3deg)`,offset:0.14},
        {transform:`translate(-${phoneApproach}px, -6px) rotate(-3deg)`,offset:0.24},
        {transform:'translate(0, 0) rotate(0deg)',offset:0.39},
        {transform:'translate(0, -3px) rotate(0deg)',offset:0.82},
        {transform:'translate(10px, 8px) rotate(5deg)',offset:1}
      ], motionTiming));
      delay(() => setStage(2), 2150);
      delay(() => setStage(3), 3600);
      delay(() => {if (demoVisible) runDemo();}, 9000);
    }
    function pauseDemo() {
      stopTimers();
      demoAnimations.forEach(animation => animation.pause());
      demo.dataset.paused = 'true';
    }
    demoImage.addEventListener('load', () => {if (demoVisible) runDemo();});
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        demoVisible = entries[0].isIntersecting;
        if (demoVisible) runDemo();
        else pauseDemo();
      }, {threshold:0.2});
      observer.observe(demo);
    } else {demoVisible = true; runDemo();}
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseDemo();
      else if (demoVisible) runDemo();
    });
    reduced.addEventListener('change', () => {if (demoVisible) runDemo();});
    const dialog = root.querySelector('[data-business-dialog]');
    const form = root.querySelector('[data-business-form]');
    const details = root.querySelector('[data-business-details]');
    const summary = root.querySelector('[data-business-summary]');
    const quantity = form.elements.quantity;
    const color = form.elements.business_color;
    const link = form.elements.business_link;
    const buy = root.querySelector('[data-business-buy]');
    const submit = root.querySelector('[data-business-submit]');
    const status = root.querySelector('[data-business-status]');
    const note = root.querySelector('[data-order-note]');
    const initialNote = note.textContent;
    let selected;
    let trigger;
    let adding = false;
    const money = cents => new Intl.NumberFormat('es-ES', {style:'currency',currency:'EUR',minimumFractionDigits:cents % 100 === 0 ? 0 : 2,maximumFractionDigits:2}).format(cents / 100);
    function syncVariant() {
      selected.variant = selected.variants.find(item => item.color === color.value) || (selected.variants.length === 1 ? selected.variants[0] : null);
      submit.disabled = adding || selected.underOrder || !selected.variant?.available;
      buy.disabled = submit.disabled;
      buy.textContent = buy.disabled ? root.dataset.unavailable : root.dataset.addLabel;
      status.textContent = submit.disabled && !adding ? root.dataset.unavailable : '';
    }
    root.querySelectorAll('[data-configure]').forEach(button => button.addEventListener('click', () => {
      if (adding) return;
      trigger = button;
      const direct = button.dataset.purchaseMode === 'direct';
      selected = {format:button.dataset.format,title:button.dataset.title,price:Number(button.dataset.price),max:Number(button.dataset.max),variants:JSON.parse(button.dataset.variants || '[]'),underOrder:button.dataset.underOrder === 'true',direct};
      form.reset();
      color.value = selected.format === 'small' ? root.dataset.bicolor : root.dataset.white;
      details.hidden = direct;
      details.querySelectorAll('input').forEach(input => {input.disabled = direct; input.setCustomValidity('');});
      quantity.max = String(selected.max);
      summary.hidden = true;
      form.hidden = false;
      buy.hidden = root.dataset.preview === 'true';
      submit.textContent = direct ? root.dataset.addLabel : root.dataset.reviewLabel;
      dialog.querySelector('h2').textContent = direct ? root.dataset.directTitle : root.dataset.configTitle;
      dialog.querySelector('.tb-dialog-intro').textContent = direct ? (selected.format === 'small' ? root.dataset.directBicolorCopy : root.dataset.directCopy) : root.dataset.configCopy;
      dialog.querySelector('[data-selected-title]').textContent = selected.title;
      dialog.querySelector('[data-selected-price]').textContent = money(selected.price);
      note.textContent = root.dataset.preview === 'true' ? initialNote : direct ? root.dataset.directNote : root.dataset.configuredNote;
      syncVariant();
      dialog.showModal();
    }));
    root.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => trigger?.focus());
    details.querySelectorAll('input').forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));
    function showSummary() {
      summary.querySelector('[data-summary-configuration]').textContent = selected.order.properties['Configuración'];
      summary.querySelectorAll('[data-config-summary]').forEach(row => {row.hidden = selected.direct;});
      summary.querySelector('[data-summary-business]').textContent = form.elements.business_name.value.trim() + ' · ' + form.elements.business_city.value.trim();
      summary.querySelector('[data-summary-quantity]').textContent = String(selected.order.quantity);
      summary.querySelector('[data-summary-color]').textContent = color.value;
      summary.querySelector('[data-summary-link]').textContent = link.value.trim() || root.dataset.emptyLink;
      summary.querySelector('[data-summary-total]').textContent = money(selected.price * selected.order.quantity);
      form.hidden = true;
      summary.hidden = false;
      summary.focus();
    }
    async function addSelection() {
      if (root.dataset.preview === 'true' || adding || !selected?.variant?.available || selected.underOrder) return;
      const payload = {items:[{id:selected.variant.id,...selected.order}]};
      adding = true;
      buy.disabled = true;
      submit.disabled = true;
      status.textContent = root.dataset.addingLabel;
      try {
        const response = await fetch(root.dataset.cartAddUrl + '.js', {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.cartError);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        adding = false;
        syncVariant();
        status.textContent = error.message || root.dataset.cartError;
      }
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (adding) return;
      const rawLink = link.value.trim();
      if (!selected.direct) {
        form.elements.business_name.setCustomValidity(form.elements.business_name.value.trim() ? '' : root.dataset.nameRequired);
        form.elements.business_city.setCustomValidity(form.elements.business_city.value.trim() ? '' : root.dataset.cityRequired);
        if (rawLink) {
          try {
            const parsed = new URL(/^https?:\/\//i.test(rawLink) ? rawLink : 'https://' + rawLink);
            const host = parsed.hostname.toLowerCase();
            const googleHost = host === 'google.com' || host.endsWith('.google.com') || host === 'google.es' || host.endsWith('.google.es') || host === 'maps.app.goo.gl' || host === 'g.page' || host === 'goo.gl';
            if (!googleHost || !['http:', 'https:'].includes(parsed.protocol)) throw new Error('invalid');
          } catch {
            link.setCustomValidity(root.dataset.invalidLink);
          }
        }
      }
      if (!form.reportValidity()) return;
      const units = Number(quantity.value);
      if (!Number.isInteger(units) || units < 1 || units > selected.max) return;
      syncVariant();
      if (submit.disabled) return;
      const properties = {'Color':color.value,'Configuración':selected.direct ? root.dataset.directChoice : root.dataset.configuredChoice};
      if (!selected.direct) Object.assign(properties,{'Negocio':form.elements.business_name.value.trim(),'Ciudad':form.elements.business_city.value.trim(),'Enlace de Google':rawLink || root.dataset.emptyLink});
      selected.order = {quantity:units,properties};
      if (selected.direct && root.dataset.preview !== 'true') addSelection();
      else showSummary();
    });
    root.querySelector('[data-summary-edit]').addEventListener('click', () => {
      summary.hidden = true;
      form.hidden = false;
      (selected.direct ? quantity : form.elements.business_name).focus();
    });
    buy.addEventListener('click', addSelection);
  }
  document.querySelectorAll('[data-business-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-business-root]').forEach(init));
})();


